import { useState } from 'react';
import OverlayCommon from './OverlayCommon';

const RefreshGridBtn = ({ onClickRefreshBtn }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <OverlayCommon toolTipText={"Refresh"}>
            <button
                onClick={onClickRefreshBtn}
                className="rs_h_controller rs_setvalue_btn visible_on_select_item refresh-btn-hover-refresh"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            > 
                <img
                    className="img-fluid refresh-icon"
                    src={isHovered ? '/images/icons/refresh-blue.svg' : '/images/icons/refresh-cw.svg'}
                    alt="refresh-logo"
                />
            </button>
        </OverlayCommon>
    );
};

export default RefreshGridBtn;